<template>
    <section
        class="property">
        <template v-if="renderComponent">
            <filters
                :filter-data="jsonFilterData"
                :offers-count="offersCount"
                @update-filter="filterHandler"
                @reset-filter="resetFilter"
                @update-view-mode="updateViewMode"
                @submit-filter-data="submitFilterData" />
            <div
                class="property__wrapper"
                ref="list">
                <Loader v-if="propertyItemsIsLoading" />
                <list
                    v-if="propertyItems?.data.length > 0 || jsonOffersData"
                    :offers-data="getOffersData"
                    :map-points="mapPoints"
                    :view-mode="VIEW_MODE"
                    @pagination-handler="paginationHandler" />
                <empty-list
                    v-else
                    :text="emptyList.text"
                    :btn-text="emptyList.btnText"
                    @btnClick="emptyListHandler" />
            </div>
        </template>
        <form-news :regions-data="jsonFilterData.regions" />
        <filter-links
            v-if="jsonFilterData"
            :title="'Субъект РФ'"
            :items="jsonFilterData.regions" />
        <filter-links
            v-if="jsonFilterData"
            :title="'Тип жилья'"
            :items="jsonFilterData.object_type" />
    </section>
</template>

<script>
    import {propertyItemsActionTypes} from '../../store/modules/land/property/modules/property-items'
    import {mapPointsActionTypes} from '../../store/modules/land/property/modules/map-points'

    import {mapState} from 'vuex'
    import URLHelper from '../../modules/URLHelper'
    import axios from 'axios'

    import Filters from './components/Filters'
    import List from './components/List'
    import Loader from '../../vue-components/Loader'
    import FormNews from './components/FormNews'
    import EmptyList from './components/EmptyList'
    import FilterLinks from './components/FilterLinks'

    export default {
        name: 'Property',
        components: {
            Filters,
            List,
            Loader,
            FormNews,
            EmptyList,
            FilterLinks
        },
        data() {
            return {
                renderComponent: true,
                apiUrlFilter: '/api/v2/land/property/filters/',
                apiUrlList: '/api/v2/land/property/items/',
                apiUrlMap: '/api/v2/land/property/map/',
                jsonFilterData: null,
                jsonOffersData: null,
                offersCount: null,
                API_PARAMS: '',
                HISTORY_PARAMS: '',
                VIEW_MODE: 'view-blocks',
                emptyList: {
                    text: 'Нет объектов по выбранным параметрам, выберите другие параметры',
                    btnText: 'Очистить фильтр'
                }
            }
        },
        computed: {
            ...mapState({
                propertyItemsIsLoading: state => state.propertyItems.isLoading,
                propertyItems: state => state.propertyItems.data,
                propertyItemsError: state => state.propertyItems.error,
                mapPointsIsLoading: state => state.mapPoints.isLoading,
                mapPoints: state => state.mapPoints.data,
                mapPointsError: state => state.mapPoints.error,
            }),

            getOffersData () {
                return this.propertyItems ? this.propertyItems : this.jsonOffersData
            },

            isMobile () {
                return typeof window === 'object' && window.innerWidth < 768
            },
        },
        methods: {
            forceRerender() {
                this.renderComponent = false;

                this.$nextTick(() => {
                    this.renderComponent = true;
                });
            },

            emptyListHandler () {
                this.resetFilter()
                this.forceRerender()
                this.submitFilterData()
            },

            submitFilterData () {
                this.jsonOffersData = null
                this.$store.dispatch(mapPointsActionTypes.getMapPoints, {apiUrl: `${this.apiUrlMap}?${this.API_PARAMS}`})
                this.$store.dispatch(propertyItemsActionTypes.getPropertyItems, {apiUrl: `${this.apiUrlList}?${this.API_PARAMS}`})
            },

            filterHandler (apiParams, historyParams) {
                this.API_PARAMS = apiParams
                this.HISTORY_PARAMS = historyParams
                this.getCountItems()
                this.setHistoryParams()
            },

            setHistoryParams () {
                if (this.HISTORY_PARAMS) {
                    history.pushState(null, null, `${window.location.origin}${window.location.pathname}?${this.HISTORY_PARAMS}`);
                    return
                }
                history.pushState(null, null, `${window.location.origin}${window.location.pathname}`);
            },

            getCountItems () {
                let apiUrl = `${this.apiUrlList}?get_count=y`
                if (this.API_PARAMS) {
                    apiUrl = `${this.apiUrlList}?${this.API_PARAMS}&get_count=y`
                }

                axios({
                    method: 'get',
                    url: apiUrl
                })
                .then((response) => {
                    this.offersCount = response.data.data
                });
            },

            updateViewMode (value) {
                this.VIEW_MODE = value
            },

            resetFilter () {
                this.API_PARAMS = ''
                this.HISTORY_PARAMS = ''
                this.getCountItems()
                history.pushState(null, null, `${window.location.origin}/property/`);
            },

            paginationHandler (value) {
                if (this.API_PARAMS) {
                    let params = this.API_PARAMS.split(`&page=`)
                    if (params[1]) {
                        this.API_PARAMS = params[0] + `&page=${value}`
                        this.HISTORY_PARAMS = params[0] + `&page=${value}`
                    } else {
                        params = this.API_PARAMS.split(`page=`)
                        if (params[1]) {
                            this.API_PARAMS = params[0] + `page=${value}`
                            this.HISTORY_PARAMS = params[0] + `page=${value}`
                        } else {
                            this.API_PARAMS += `&page=${value}`
                            this.HISTORY_PARAMS += `&page=${value}`
                        }
                    }
                } else {
                    this.API_PARAMS = `page=${value}`
                    this.HISTORY_PARAMS = `page=${value}`
                }
                
                this.setHistoryParams()

                if (this.isMobile) {
                    this.jsonOffersData = null
                    this.$store.dispatch(mapPointsActionTypes.getMapPoints, {apiUrl: `${this.apiUrlMap}?${this.API_PARAMS}`})
                    this.$store.dispatch(propertyItemsActionTypes.getMoreData, {apiUrl: `${this.apiUrlList}?${this.API_PARAMS}`})
                    return
                }

                this.submitFilterData()
            },

            setListHeight () {
                setTimeout(() => {
                    this.$refs.list.style.maxHeight = `${this.$refs.list.scrollHeight}px`
                }, 100)
            }
        },
        watch: {
            'propertyItems'(newVal) {
                const title = document.querySelector('.property__title')
                if (title) {
                    title.textContent = newVal.meta.title
                }
            }
        },
        created() {
            const dataContainer = document.querySelector('auctions-list-page')
            if (dataContainer) {
                this.jsonFilterData = JSON.parse(dataContainer.getAttribute('filters-data'))
                this.jsonOffersData = JSON.parse(dataContainer.getAttribute('renders-data'))
                this.offersCount = this.jsonOffersData.nav.NavRecordCount
            }

            if (URLHelper.getParamVal('VIEW_MODE')) {
                this.VIEW_MODE = URLHelper.getParamVal('VIEW_MODE')
            }
        },
        mounted() {
            this.submitFilterData()
        }
    }
</script>
